import React from 'react';
import Helmet from 'components/Helpers/Helmet';
import { withRouteParams } from 'hoc/withRouteParams';
import { includes, isEmpty } from 'lodash';
import ScrollToTop from 'components/UI/ScrollToTop';
import Footer from 'components/Components/Sections/Footer';
import Header from 'components/Components/Sections/Header';
import { loadAllRegions } from 'store/dispatchers/regions.dispatchers';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { buildMetaRegionsSelector, buildRegionsSelector } from 'store/selectors/regions.selector';
import ThemeContext from '../ThemeContext';

class DefaultLayout extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            headerConfig: { ...Header.defaultProps, ...this.getHeaderDefaults(props.router.location) },
            onHeightChange: (h) =>
            {},
            redirectUrl: null,
            headerPhoneNumber: '',
        };
        this.configHeader = this.configHeader.bind(this);
        this.setHeightChange = this.setHeightChange.bind(this);
        this._loadDataIfNeeded = this._loadDataIfNeeded.bind(this);

        this.redirecting = false;
        this.regionsLoadTimer = null;
        this.loadedFromFront = false;
    }

    componentDidMount()
    {
        this.regionsLoadTimer = setTimeout(() => this._loadDataIfNeeded(), 10000);
    }

    _loadDataIfNeeded()
    {
        const { regions, metaRegions } = this.props;

        if ((isEmpty(regions) && !metaRegions.loading) || !this.loadedFromFront)
        {
            this.props.loadAllRegions();
            this.loadedFromFront = true;
        }
    }

    configHeader(headerConfig)
    {
        this.setState(prevState => ({
            headerConfig: {
                ...prevState.headerConfig, ...headerConfig,
            },
        }));
    }

    getHeaderDefaults(location)
    {
        const whiteHeaderPages = ['/hotels', '/destinations', '/about-us'];

        if (includes(whiteHeaderPages, location.pathname))
        {
            return { defaultBg: 'header-white' };
        }

        return { defaultBg: 'header-transparent' };
    }

    setHeightChange(f)
    {
        if (!f)
        {
            f = (h) =>
            {};
        }
        this.setState({ onHeightChange: f });
    }

    handleHeaderPhoneNumberTextChange = (text) => {
        this.setState({ headerPhoneNumber: text });
    };

    render()
    {
        return (
            <>
                <Helmet>
                    <title>Luxuria Vacations</title>
                    <meta name="description" content="Luxuria Vacations" />
                </Helmet>

                <Header {...this.state.headerConfig} onChange={this.state.onHeightChange} onLoadData={this._loadDataIfNeeded} onHeaderPhoneNumberTextChange={this.handleHeaderPhoneNumberTextChange} />

                <ThemeContext.Provider
                    value={{
                        themeContext: {
                            configHeader: this.configHeader,
                            loadRegions: this._loadDataIfNeeded,
                            setHeightChange: this.setHeightChange,
                            headerPhoneNumber: this.state.headerPhoneNumber,
                        },
                    }}
                >
                    <ScrollToTop />

                    {this.props.children}

                </ThemeContext.Provider>

                <Footer />
            </>

        );
    }
}

DefaultLayout.propTypes = {
    metaRegions: PropTypes.object,
};

const mapStateToProps = () =>
{
    const metaRegionsSelector = buildMetaRegionsSelector();
    const regionsSelector = buildRegionsSelector();

    return state => ({
        metaRegions: metaRegionsSelector(state),
        regions: regionsSelector(state),
    });
};
const mapDispatchToProps = dispatch => ({
    loadAllRegions()
    {
        return dispatch(loadAllRegions());
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouteParams(DefaultLayout));
